// Simplified field validators for v1.18.0 compatibility
// Complex generic types have been removed to maintain functionality
// This provides basic field validation capabilities

export type FieldValidatorProps = {
  validator?: (props: any) => string | undefined
  asyncValidator?: (props: any) => Promise<string | undefined> | string | undefined
  listenTo?: string[]
  ignoreEvents?: ('blur' | 'change' | 'submit' | 'mount')[]
}

export const createFieldValidator = (
  props: FieldValidatorProps,
  options?: {
    shouldValidate?: (fieldApi?: any) => boolean
  },
) => {
  const fieldValidator = {} as any
  const { validator, asyncValidator, listenTo, ignoreEvents } = props
  const shouldValidate = options?.shouldValidate

  if (!ignoreEvents?.includes('blur')) {
    fieldValidator.onBlurListenTo = listenTo
    fieldValidator.onBlurAsyncDebounceMs = asyncValidator ? 500 : undefined

    if (validator) {
      fieldValidator.onBlur = (props: any) => {
        if (!shouldValidate || shouldValidate(props.fieldApi)) {
          return validator(props)
        }
      }
    }

    if (asyncValidator) {
      fieldValidator.onBlurAsync = (props: any) => {
        if (!shouldValidate || shouldValidate(props.fieldApi)) {
          return asyncValidator(props)
        }
      }
    }
  }

  if (!ignoreEvents?.includes('change')) {
    fieldValidator.onChangeListenTo = listenTo

    // For onChange, only run the validator if the field is dirty so that
    // we don't show errors on fields that haven't been interacted with yet
    if (validator) {
      fieldValidator.onChange = (props: any) => {
        if (!shouldValidate || shouldValidate(props.fieldApi)) {
          return validator(props)
        }
      }
    }

    if (asyncValidator) {
      fieldValidator.onChangeAsync = (props: any) => {
        if (!shouldValidate || shouldValidate(props.fieldApi)) {
          return asyncValidator(props)
        }
      }

      fieldValidator.onChangeAsyncDebounceMs = 500
    }
  }

  if (!ignoreEvents?.includes('submit')) {
    fieldValidator.onSubmit = validator
    fieldValidator.onSubmitAsync = asyncValidator
  }

  return fieldValidator
}
